import { resources } from "@/@core/utils/enum/user";

const state = () => ({
  accessToken: "",
  user: "",
  ability: "",
  error: null,
  permissions: [],
});

export default {
  namespaced: true,

  state: state(),

  getters: {
    isLoggedIn(s) {
      return !!s.accessToken;
    },
  },

  mutations: {
    SET_AUTH: (s, payload) => {
      s.accessToken = payload.accessToken;
      s.user = payload;
    },
    SET_ABILITY: (s, payload) => (s.ability = payload),
    PURGE_AUTH: (s) => Object.assign(s, state()),
    SET_PERMISSIONS(s, payload) {
      const groupedPermissions = {};

      if (payload.some((i) => i.code.includes("full"))) {
        const accumulator = resources.reduce((acc, currentResource) => {
          acc[currentResource.key] = "admin";
          return acc;
        }, {});
        accumulator.full_access = "admin";
        s.permissions = accumulator;
        return;
      }

      payload.forEach((p) => {
        const hasActionSuffix =
          p.code.endsWith("_read") ||
          p.code.endsWith("_write") ||
          p.code.endsWith("_delete");

        if (hasActionSuffix) {
          const lastUnderscoreIndex = p.code.lastIndexOf("_");
          const sectionKey = p.code.substring(0, lastUnderscoreIndex);

          if (!groupedPermissions[sectionKey]) {
            groupedPermissions[sectionKey] = {
              read: false,
              write: false,
              delete: false,
            };
          }
          if (p.code.endsWith("_read")) {
            groupedPermissions[sectionKey].read = true;
          } else if (p.code.endsWith("_write")) {
            groupedPermissions[sectionKey].write = true;
          } else if (p.code.endsWith("_delete")) {
            groupedPermissions[sectionKey].delete = true;
          }
        } else {
          // Plain resource code (no action suffix) — grant full access
          groupedPermissions[p.code] = { read: true, write: true, delete: true };
        }
      });
      const finalData = {};
      for (const section in groupedPermissions) {
        const { read, write, delete: del } = groupedPermissions[section];

        if (read && write && del) {
          finalData[section] = "admin";
        } else if (write) {
          finalData[section] = "write";
        } else if (read) {
          finalData[section] = "read";
        } else {
          finalData[section] = "none";
        }
      }

      const allSections = resources.map((resource) => resource.key);
      allSections.forEach((section) => {
        if (!finalData[section]) {
          finalData[section] = "none";
        }
      });
      s.permissions = finalData;
    },
  },

  actions: {
    setAuth({ commit }, payload) {
      commit("SET_AUTH", payload);
    },
    setAbility({ commit }, payload) {
      commit("SET_ABILITY", payload);
    },
    purgeAuth({ commit, dispatch }) {
      commit("PURGE_AUTH");
    },
    setPermissions({ commit }, payload) {
      commit("SET_PERMISSIONS", payload);
    },
  },
};
